import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

import identificationTypes from "../../data/identificationTypes.json";

export const LegalRepresenForm = ({ dto, errorInputs, handleInputChange, t }) => {

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12}}>
                <Typography variant="h6">{t("suppliers.legalRepresentative")}</Typography>
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <FormControl
                    fullWidth
                    size='small'
                    error={Boolean(errorInputs.reprecentant_type?.isError)}
                    required
                >
                    <InputLabel id="representative-type-label">{t("suppliers.legalRepresentative.type")}</InputLabel>
                    <Select
                        label={t("suppliers.legalRepresentative.type")}
                        name='reprecentant_type'
                        value={dto.reprecentant_type}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="Principal">Principal</MenuItem>
                        <MenuItem value="Suplente">Suplente</MenuItem>
                    </Select>
                    {errorInputs.reprecentant_type?.isError && (
                        <FormHelperText>{errorInputs.reprecentant_type.messageError}</FormHelperText>
                    )}
                </FormControl>
            </Grid>

            <Grid size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth size="small"
                    error={Boolean(errorInputs.reprecentant_id_type?.isError)}
                    required
                >
                    <InputLabel>{t("commonFields.identificationType")}</InputLabel>
                    <Select
                        label={t("commonFields.identificationType")}
                        name="reprecentant_id_type"
                        value={dto.reprecentant_id_type}
                        onChange={handleInputChange}
                    >
                        {identificationTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {errorInputs.reprecentant_id_type?.isError && (
                        <FormHelperText>{errorInputs.reprecentant_id_type.messageError}</FormHelperText>
                    )}
                </FormControl>
            </Grid>


            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    name='reprecentant_id'
                    label={t("commonFields.idNumber")}
                    value={dto.reprecentant_id || ''}
                    onChange={handleInputChange}
                    error={!!errorInputs.reprecentant_id?.isError}
                    helperText={errorInputs.reprecentant_id?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    name='reprecentant_name'
                    label={t("commonFields.fullName")}
                    value={dto.reprecentant_name || ''}
                    onChange={handleInputChange}
                    error={!!errorInputs.reprecentant_name?.isError}
                    helperText={errorInputs.reprecentant_name?.messageError}
                    required
                />
            </Grid>
        </Grid>
    );
};
